var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9328 38.5989L37.8729 33.1023L36.4562 29.3191C36.1362 28.3424 35.5929 27.4557 34.8663 26.7291L31.593 23.4558L23.1064 31.9423L26.3797 35.2156C27.1064 35.9423 27.993 36.4856 28.9697 36.8056L32.753 38.2222L38.2495 40.2822C39.2862 40.6189 40.2695 39.6356 39.9328 38.5989Z",
    fill: "url(#paint0_linear_1023_7816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2496 40.2825L33.6963 38.5758C34.1863 37.6058 34.8263 36.7225 35.5996 35.9525C36.3696 35.1825 37.2496 34.5426 38.2262 34.0459L39.9329 38.5992C40.2695 39.6358 39.2862 40.6191 38.2496 40.2825Z",
    fill: "url(#paint1_linear_1023_7816)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8669 7.72945L7.38033 16.216L4.55371 13.386L13.0369 4.90283L15.8669 7.72945Z",
    fill: "url(#paint2_linear_1023_7816)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49609 14.3303L13.9812 5.84526L14.9239 6.78804L6.43888 15.2731L5.49609 14.3303Z",
    fill: "#9E9E9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0365 4.90287L4.55326 13.3861L0.779988 9.61613C-0.259996 8.57614 -0.259996 6.88617 0.779988 5.84619L5.49658 1.1296C6.53656 0.0896135 8.22653 0.0896135 9.26652 1.1296L13.0365 4.90287Z",
    fill: "url(#paint3_linear_1023_7816)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89355 13.7027L13.3502 10.2461L30.8066 27.7025L30.8366 28.3825C30.8999 29.8491 29.4966 31.2524 28.0299 31.1891L27.3499 31.1591L9.89355 13.7027Z",
    fill: "url(#paint4_linear_1023_7816)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37988 16.2159L25.6129 34.449C26.6362 34.019 27.4296 32.949 27.3796 31.839L27.3496 31.159L9.89318 13.7026L7.37988 16.2159Z",
    fill: "url(#paint5_linear_1023_7816)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3535 10.2428L30.8099 27.6992L31.4899 27.7292C32.5999 27.7758 33.6732 26.9859 34.0999 25.9625L15.8668 7.72949L13.3535 10.2428Z",
    fill: "url(#paint6_linear_1023_7816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_7816",
    x1: 31.5533,
    y1: 6.28942,
    x2: 31.5533,
    y2: 39.3122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006854,
    stopColor: "#FFECB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1023_7816",
    x1: 36.8482,
    y1: 34.168,
    x2: 36.8482,
    y2: 39.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504F4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1023_7816",
    x1: 10.2103,
    y1: 3.09953,
    x2: 10.2103,
    y2: 17.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1023_7816",
    x1: 6.51823,
    y1: -1.59479,
    x2: 6.51823,
    y2: 12.1721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E57373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F44336"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1023_7816",
    x1: 20.3661,
    y1: 4.40519,
    x2: 20.3661,
    y2: 29.3475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1023_7816",
    x1: 6.16429,
    y1: 12.487,
    x2: 23.0166,
    y2: 29.3393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1023_7816",
    x1: 12.1379,
    y1: 6.51388,
    x2: 28.9902,
    y2: 23.3662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencile);
export default __webpack_public_path__ + "static/media/pencile.65774546d6dc056288b17c47182f8e31.svg";
export { ForwardRef as ReactComponent };